import type {
  LeadershipWheelPageQuery,
  LeadershipWheelQuery,
  LeadershipWheel,
  LeadershipWheelPage,
} from '@edwin-group/people-graphql';
import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import {
  MUTATION_UPDATE_STAFF_ONBOARD_LEADERSHIP_WHEEL,
  QUERY_LEADERSHIP_WHEEL,
  QUERY_LEADERSHIP_WHEEL_PAGE,
  //   MUTATION_UPDATE_USER_TRACKING,
} from '@edwin-group/people-graphql';
import { getAuthentication } from '@/hooks/useAuthentication';

export const getPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<LeadershipWheelPageQuery>({
      query: QUERY_LEADERSHIP_WHEEL_PAGE,
      fetchPolicy: 'cache-first',
    }),
  );

  return {
    page: data?.leadershipWheelPage?.data?.attributes as LeadershipWheelPage,
    error,
  };
};

export const getLeadershipWheel = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<LeadershipWheelQuery>({
      query: QUERY_LEADERSHIP_WHEEL,
    }),
  );

  return {
    focusAreas: data?.leadershipWheel?.data as LeadershipWheel[],
    error,
  };
};

export async function onChangeTrackingTraits(disable: boolean) {
  return Promise.resolve({ disable });
  // const apolloClient = initializeApollo();
  // const { data } = await requestHandler(
  //   apolloClient.mutate({
  //     mutation: MUTATION_UPDATE_USER_TRACKING,
  //     variables: {
  //       id: getAuthentication()?.user?.id,
  //       input: {
  //         isCharacterCompassTrackingDisabled: disable,
  //       },
  //     },
  //   }),
  // );
  // return data?.updateUsersPermissionsUser?.data?.attributes;
}

export async function onChangeOnboardStatus() {
  const apolloClient = initializeApollo();
  const { data } = await requestHandler(
    apolloClient.mutate<{ updateUsersPermissionsUser: { data: { attributes: unknown } } }>({
      mutation: MUTATION_UPDATE_STAFF_ONBOARD_LEADERSHIP_WHEEL,
      variables: {
        id: getAuthentication()?.user?.id,
        input: {
          onboardLeadershipWheelCompleted: true,
        },
      },
    }),
  );
  return data?.updateUsersPermissionsUser?.data?.attributes;
}
